<template>
    <project-step-container
            prev-to="be_deep_customer_empathy_2"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject">
        <b-row class="first-form">
            <b-col cols="12" class="text-center">
              <JAVideo
                :poster="{src: srcPoster, title:'Job Shadow Video'}"
                title="Deep Customer Empathy"
                :sources="videoSources"/>
            </b-col>
            <b-col cols="12" class="mt-4 simple-text" tabindex="0">
                {{getMessage(3, 'empathy-map-sub')}}
            </b-col>

        </b-row>

    </project-step-container>
</template>

<script>
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import ProjectStepActivity from "../../../core/Components/ProjectStepActivity"
    import JAVideo from "../../../core/Components/JAVideo"
    import {Steps} from "@/modules/BeEntrepreneurship/Utils";
    import {ConflictSyn, Project} from "@/core/Utils";

    export default {
        name: "DeepCustomerEmpathy3",
        components: {ProjectStepContainer, ProjectStepActivity, JAVideo},
        data() {
            return {
                step:Steps.FORM_DEVELOP_EMPATHY,
            }
        },
        computed: {
            srcPoster() {
                if (this.isJACareerEntrepreApp) {
                    return require('../Images/ja-deep-customer-empathy-thumbnail_new_logo.png');
                }

                return require('../Images/ja-deep-customer-empathy-thumbnail.jpg');
            },
            videoSources() {
                if (this.isJACareerEntrepreApp) {
                    return [
                        {
                            src: 'https://data.ja.org/s/ID0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 1440px)'
                        },
                        {
                            src: 'https://data.ja.org/s/Hz0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 960px)'
                        },
                        {
                            src: 'https://data.ja.org/s/Hj0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 720px)'
                        },
                        {
                            src: 'https://data.ja.org/s/HT0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 480px)'
                        },
                        {
                            src: 'https://data.ja.org/s/HD0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 360px)'
                        },
                        {
                            src: 'https://data.ja.org/s/Gz0AAA',
                            type: 'video/mp4',
                        },

                    ]
                }

                return [{
                    src: 'https://jad4dmedia-usso.streaming.media.azure.net/ceb8033d-7610-4f80-8d0d-14d479f8cdd5/Step3_DeepCustomerEmpathy.ism/manifest',
                    type: 'application/vnd.ms-sstr+xml'
                }];
            }
        },
        methods: {
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index

                Project.saveProjectStep(index, this.step, stepNumber, {}, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: 'be_deep_customer_empathy_4', params: {index}})
            }
        }
    }
</script>
